<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/call/call-driver" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>{{race?.raceType.includes('Scheduled') ? 'Trip Scheduled' : 'Driver Coming'}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="top-informations" style="flex-direction: row-reverse;">
      <div class="value-bigger" style="text-align: right;">
        <span>Trip</span>
        <span>{{ race?.valorCorrida | currency }}</span>
      </div>
      <div class="data-user">
        <div class="block">
          <div class="ico" style="width: 40px; height: 40px; align-self: flex-start;">
            <ion-img src="assets/images/avatar-motorista-volante.png" />
          </div>
          <h3 style="    margin-right: 20px;">
            {{ race?.motorista?.nome }}
            <small class="detail"> {{ race?.motorista?.veiculo?.placa }} / {{ race?.motorista?.veiculo?.cor }}
              {{race?.motorista?.veiculo?.marca}} <br /> {{ race?.motorista?.veiculo?.modelo
              }}</small>
          </h3>
        </div>
      </div>
    </div>
  <div class="informations-complementary">
    <div class="block map">
      <app-dashboard-map *ngIf="race && race.motorista && race.motorista.id && origin && destination"
        [driverId]="race.motorista.id" [latLngDirectionFrom]="origin" [latLngDirectionTo]="destination"
        [showEstablishmentMarkers]="false" style="display: contents;"></app-dashboard-map>
    </div>
    <div class="block" *ngIf="race.raceType.includes('Scheduled')">
      <h4><ion-icon name="pin"></ion-icon> Date</h4>
      <p>{{dataCorridaAgendada | date:"MM/dd/yyyy h:mm a"}}</p>
    </div>
    <div class="block">
      <h4><ion-icon name="pin"></ion-icon> Destination</h4>
      <p>{{ race?.enderecoDestino }}</p>
    </div>
    <div class="block">
      <h4><ion-icon name="contract"></ion-icon> Trip</h4>
      <p>{{ race?.raceType }}</p>
    </div>
    <div class="block" *ngIf="this.claim === this.userType.Caller && !race?.raceType.includes('Scheduled')">
      <h4><ion-icon name="time"></ion-icon> Estimated time <br> to arrive</h4>
      <p>{{ eta }}</p>
    </div>
    <div class="block" *ngIf="this.claim === this.userType.Caller">
      <h4><ion-icon name="cash"></ion-icon> Amount to <br> receive</h4>
      <p>{{ race?.repasseVendedor | currency }}</p>
    </div>
  </div>
  <footer class="ion-padding actions">
    <button class="button-outline" (click)="cancelRace()">Cancel</button>
    <a href="tel:{{race?.motorista?.celular}}" class="button-bigger blue">
      <ion-icon name="call"></ion-icon> Call Driver
    </a>
    <button class="button-bigger" (click)="newTrip()">New Trip</button>
  </footer>

  <div *ngIf="isOpenCanceling" class="container-comment" [ngClass]="{ open: isOpenCanceling }">
    <form [formGroup]="formCancelation">
      <h3>
        <ion-icon name="chatbox"></ion-icon>
        Please place the reason for the cancellation.
      </h3>

      <div class="container">
        <input formControlName="motivoCancelamento" type="text" class="input" placeholder="Enter reason" />
        <ion-button shape="round" size="small" (click)="postReason()"
          [disabled]="formCancelation.invalid">Send</ion-button>
      </div>
    </form>
  </div>
</ion-content>